module.exports = __webpack_public_path__ + "img/child-in-class.c229a1d9.webp";